import { Component, inject } from '@angular/core';
import { ViaSicfeTransportService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ViaSicfeTransportCreateDto,
  ViaSicfeTransportDto,
  ViaSicfeTransportExcelDownloadDto,
  ViaSicfeTransportUpdateDto,
} from '../proxy/controlling/dtos/via-sicfe-transport';
import { VIASICFETRANSPORT_CONFIG, VIASICFETRANSPORT_FIELDS } from './via-sicfe-transport.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-via-sicfe-transport',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ViaSicfeTransportService, ConfirmationService],
  templateUrl: './via-sicfe-transport.html',
  styleUrl: './via-sicfe-transport.scss',
})
export class ViaSicfeTransport extends BaseCrudComponent<
  ViaSicfeTransportDto,
  ViaSicfeTransportCreateDto,
  ViaSicfeTransportUpdateDto,
  ViaSicfeTransportExcelDownloadDto
> {
  service = inject(ViaSicfeTransportService);
  config = VIASICFETRANSPORT_CONFIG;
  fields = VIASICFETRANSPORT_FIELDS;

  protected prepareUpdateDto(data: any, selected: ViaSicfeTransportDto): ViaSicfeTransportUpdateDto {
    return {
      name: data.name,
      value: data.value,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ViaSicfeTransport';
  }
}
